import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TSButton from 'components/common/Button/Button';

import { ROUTES } from 'constants/RoutePaths';
import { buildRoutePath } from 'utils/utility';

import { isUserAuth, userToken } from '_actions/user_actions';
import { useGetUserDetailsQuery } from 'app/api/usersApiSlice';
import { Expand } from '@mui/icons-material';
import EmergencyContact from '../EmergencyContact/EmergencyContact';
import MLModal from 'components/common/Modal/Modal';

const UserProfile = () => {
  const navigate = useNavigate();

  const [isAuth, setIsAuth] = useState(false);
  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [editMode, setEditMode] = useState([]);
  const [expandedPanel, setExpandedPanel] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const userEmail = useSelector((state) => state.global?.userEmail);

  useEffect(() => {
    const checkAuth = async () => {
      const t = await userToken();
      setIsAuth(!!t);
      setToken(t);
    };
    checkAuth();
    setIsLoading(false);
  }, []);

  const { data: userData, isLoading: isUserLoading } = useGetUserDetailsQuery(
    userEmail,
    { skip: !userEmail }
  );

  const emCont = userData?.[0]?.emergency_contacts
    ? [...userData?.[0]?.emergency_contacts]
    : [];

  const handlePanel = (contactId) => {
    setExpandedPanel((prev) => (prev === contactId ? false : contactId));
  };

  const toggleModal = (state) => {
    setIsModalOpen(state);
  };

  if (isLoading || isUserLoading) {
    return <div>Loading...</div>;
  } else {
    return (
      <>
        <div className="px-4 py-2">
          <Typography className="py-2" variant="h2">
            Profile
          </Typography>
          <Typography className="py-2" variant="body1">
            Welcome to TrailSafe {userData?.[0]?.full_name}!
          </Typography>

          <Typography className="py-2" variant="h2">
            Emergency Contacts ({userData[0]?.emergency_contacts?.length ?? 0})
          </Typography>

          {emCont.length > 0 &&
            emCont
              .sort((a, b) => a.ContactName.localeCompare(b.ContactName))
              .map((contact, index) => {
                return (
                  <Accordion
                    key={index}
                    expanded={expandedPanel === contact.EmergencyContactID}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      onClick={() => handlePanel(contact.EmergencyContactID)}
                      aria-controls="panel3-content"
                      id="panel3-header"
                    >
                      <Typography component="span">
                        {contact.ContactName}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <EmergencyContact
                        contact={contact}
                        userId={userData[0].user_id}
                        index={index}
                      />
                    </AccordionDetails>
                    {/* <AccordionActions>
                    <Button>Edit</Button>
                    <Button>Delete</Button>
                  </AccordionActions> */}
                  </Accordion>
                );
              })}
          <div className="py-2">
            <TSButton
              btnText="Add contact"
              btnVariant="outlined"
              onClickFunc={() => toggleModal(true)}
            />
          </div>
        </div>
        <MLModal open={isModalOpen} setOpenModal={setIsModalOpen}>
          <EmergencyContact
            contact={null}
            userId={userData[0].user_id}
            index={99}
            isModal={true}
            toggleModal={setIsModalOpen}
          />
        </MLModal>
      </>
    );
  }
};

export default UserProfile;
